import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const CookieBanner = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };
  
  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setIsVisible(false);
  };
  
  if (!isVisible) return null;
  
  const text = language === 'sl' 
    ? {
        message: 'Ta spletna stran uporablja nujne piškotke za delovanje. Ne uporabljamo piškotkov za sledenje ali oglaševanje.',
        privacy: 'Več o zasebnosti',
        accept: 'Sprejmi',
        reject: 'Zavrni'
      }
    : {
        message: 'This website uses essential cookies for functionality. We do not use tracking or advertising cookies.',
        privacy: 'Learn more about privacy',
        accept: 'Accept',
        reject: 'Reject'
      };
  
  return (
    <div 
      id="cookie-banner"
      className="fixed bottom-0 left-0 right-0 bg-[#0E1114] text-[#F4EFE6] px-6 py-5 flex flex-wrap items-center justify-between gap-4 z-[1000] border-t border-[#C9A462]"
      style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}
      data-testid="cookie-banner"
    >
      <p className="m-0 max-w-[800px] text-[#B9B3A7] text-[14px] leading-[1.5]">
        {text.message}{' '}
        <a 
          href={language === 'sl' ? '/zasebnost' : '/privacy'} 
          className="text-[#C9A462] underline"
        >
          {text.privacy}
        </a>
      </p>
      <div className="flex gap-2.5 flex-shrink-0">
        <button
          onClick={handleAccept}
          className="px-5 py-3 font-semibold text-[14px] cursor-pointer border-none bg-[#C9A462] text-[#0E1114]"
          style={{ fontFamily: "'Manrope', sans-serif" }}
          data-testid="cookie-accept"
        >
          {text.accept}
        </button>
        <button
          onClick={handleReject}
          className="px-5 py-3 font-semibold text-[14px] cursor-pointer bg-transparent text-[#F4EFE6] border border-[#454C54]"
          style={{ fontFamily: "'Manrope', sans-serif" }}
          data-testid="cookie-reject"
        >
          {text.reject}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
